import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Zone } from 'libs/ui';
import { Content, Count } from './zone-row.styled';

export const ZoneRow = (props) => {
  const { zone_id, zone_name, limit, maximum, free } = props;
  const { t } = useTranslation();

  const color = useMemo(() => {
    const node = window.config.objects.zones.find((item) => {
      return item.zoneId.toString() === zone_id.toString();
    });
    return node?.color ?? '#fff';
  }, [zone_id]);

  const cntAll = free + '/' + limit ?? maximum;

  // green accent when spots are free, muted when the zone is full
  const valueColor = Number(free) > 0 ? '#5cc98a' : '#7a838a';

  return (
    <Content>
      <Zone color={color} zoneId={zone_name} />
      <Count $color={valueColor}>
        <span>{t('tables.Свободно') + ':'}</span>
        <b>{cntAll}</b>
      </Count>
    </Content>
  );
};
